import { ChangeDetectorRef, Component, Inject, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { JobReferenceDto } from '../../../services/api.services';
import { InsightsJobsService, InsightsJobState } from '../../insights-jobs.service';

export interface JobProgressDialogData {
  job: JobReferenceDto;
  jobTitle: string;
  showClose?: boolean;
};

@Component({
  selector: 'app-job-progress-dialog',
  templateUrl: 'job-progress-dialog.component.html',
  standalone: false
})
export class JobProgressDialogComponent {
  completed = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: JobProgressDialogData,
    public readonly dialogRef: MatDialogRef<JobProgressDialogComponent>) { }

  setCompleted(completed: boolean) {
    this.completed = completed;
  }

  dismissAllClick() {
    this.dialogRef.close(JobProgressDialogComponent.dismissAll);
  }
};

export namespace JobProgressDialogComponent {
  export const dismissAll = {};
}
